import React, {useContext} from 'react'
import Menu from '@material-ui/icons/Menu';

import {capitalize} from '../fn'

import {appContext} from '../contexts'

const Link = props =>{
    const context = useContext(appContext)
    const name = props.children.toUpperCase();

    if(context.mode === name){
        return(
            <li className={`${name}`}>
                <a href={`#${name}`} >
                    {capitalize(name)}
                </a>

            </li>
    
        )
    }else{
        return(
            <li className={``}>
                <a href={`#${name}`} >
                    {capitalize(name)}
                </a>
    
            </li>
    
        )  
    }


}
const Nav = props => {
    return (
        <React.Fragment>
            <ul className="nav">
                <Link>ABOUT</Link>
                <Link>PROJECTS</Link>
                <Link>CONTACT</Link>
            </ul>            
            <div className="nav-button">
                <Menu onClick={props.handleClick}/>
            </div>

        </React.Fragment>
    )
}

export default Nav
